import { render, staticRenderFns } from "./sendreport.vue?vue&type=template&id=778f3dea"
import script from "./sendreport.vue?vue&type=script&lang=js"
export * from "./sendreport.vue?vue&type=script&lang=js"
import style0 from "./sendreport.vue?vue&type=style&index=0&id=778f3dea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports